/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Versions_Tool_BaselineInputs */



/**
* | output |
* | --- |
* | "Earlier state" |
*
* @param {Canvas_Versions_Tool_BaselineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_tool_baseline = /** @type {((inputs?: Canvas_Versions_Tool_BaselineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_Tool_BaselineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Früherer Stand")
	return /** @type {LocalizedString} */ ("Earlier state")
});